
// You can write more code here

/* START OF COMPILED CODE */

import PlatformImage from "../PlatformImage";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class PlatformJungleLog extends PlatformImage {

  constructor(scene: Phaser.Scene, x?: number, y?: number, texture?: string, frame?: number | string) {
    super(scene, x ?? 191, y ?? 20.5, texture || 'game-all', frame ?? "log.png");

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  public init() {
    let rect: MatterJS.BodyType = this.scene.matter.bodies.rectangle(this.x, this.y, this.displayWidth, this.displayHeight - 15, {
      render: {
        sprite: {
          xOffset: 0,
          yOffset: 0.075
        }
      }
    });
    // this.customBodies.push(rect);
    this.setExistingBody(rect);
    this.hasCustomBody = true;

    super.init();
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
